module.exports = __webpack_public_path__ + "img/e2a1afa.jpeg";